export const craftsmen = {
  emptyText1: 'Sie haben derzeit noch keine Handwerker.',
  emptyText2: 'Wenn Sie ein Projekt erstellen, erscheinen die Handwerker aus diesem Projekt hier.',
  emptyText3: 'Fügen Sie jetzt Ihren ersten Handwerker zu und profitieren Sie:',
  emptyText4: 'Kontaktadressen aller Handwerker auf einen Blick.',
  emptyText5: 'Schnell passende Handwerker finden.',
  emptyText6: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
  buttonText: 'Handwerker hinzufügen',
  createNewProject: 'Handwerker hinzufügen',
  projectStatusDescriptionStep1: 'Immobilie angelegt',
  projectStatusDescriptionStep2: 'Projekt geprüft',
  projectStatusDescriptionStep3: 'Handwerker zugewiesen',
  company: 'Firma',
  industry: 'Industrie',
  phoneNumber: 'Telefonnummer',
  emailAddress: 'E-Mail',
  address: 'Adresse',
  zipCode: 'PLZ',
  city: 'Ort',
  contactPerson: 'Ansprechpartner',
  salutation: 'Anrede',
  lastname: 'Nachname',
  firstname: 'Vorname',
  addCraftsman: 'Hinzufügen',
  craftmen: 'Handwerker',
  search: 'Suchen',
  edit: 'Bearbeiten',
  delete: 'Löschen',
  createErrorToastText: 'Handwerker konnte nicht erstellt werden',
  editSave: 'Änderungen Speichern',
  editSaveQuotesCard: 'Aktualisieren',
  editCraftsman: 'Handwerker bearbeiten',
  updateErrorToastText: 'Handwerker konnte nicht geändert werden',
  deleteErrorToastText: 'Handwerker konnte nicht gelöscht werden',
  deleteCraftsmanText: 'Sind Sie sicher, dass Sie diesen Handwerker löschen wollen?',
  deleteCraftsmanButtonText: 'Handwerker löschen',
  deleteSuccesToastText: 'Handwerker wurde erfolgreich gelöscht',
  toolTipText: 'Dieser Handwerker wurde Ihnen von HausHeld zur Verfügung gestellt',
}
